<template>
  <div class="home">
    <div>
      <el-menu
          class="el-menu-vertical-demo"
          background-color="#373737"
          text-color="#D6D6D6"
          active-text-color="#D6D6D6"
          router v-bind:default-active="$route.path">
        <div class="head-img" style="height:64px;display:flex;align-items:center;justify-content:center;background:#ffffff;">
          <img src="@/assets/logo_leaf.png" alt="" style="width:40px;height:40px;flex-shrink:0;">
          <span style="font-size:20px;font-weight:bold;color:#333333;margin-left:6px;line-height:1;">来咖云</span>
        </div>
        <el-menu-item index="/userInfo">
          <i class="el-icon-user-solid"></i>
          <span slot="title">用户信息</span>
        </el-menu-item>
        <el-menu-item index="/pointsRecord">
          <i class="el-icon-s-order"></i>
          <span slot="title">积分记录</span>
        </el-menu-item>
        <el-menu-item index="/pointsChange">
          <i class="el-icon-finished"></i>
          <span slot="title">积分变更</span>
        </el-menu-item>
        <el-menu-item index="/orderRecord">
          <i class="el-icon-document-copy"></i>
          <span slot="title">订单记录</span>
        </el-menu-item>
        <el-menu-item index="/activityInformation">
          <i class="el-icon-document"></i>
          <span slot="title">活动信息</span>
        </el-menu-item>
        <el-menu-item index="/activityProcedure">
          <i class="el-icon-files"></i>
          <span slot="title">活动过程</span>
        </el-menu-item>
        <el-menu-item index="/activityRegistrationSigninRecord">
          <i class="el-icon-s-check"></i>
          <span slot="title">报名签到记录</span>
        </el-menu-item>
        <el-menu-item index="/topicNews">
          <i class="el-icon-s-order"></i>
          <span slot="title">主题新闻</span>
        </el-menu-item>
        <el-menu-item index="/log">
          <i class="el-icon-s-order"></i>
          <span slot="title">日志</span>
        </el-menu-item>
        <!-- 志愿中心一期：权限码 volunteer:audit。超管可见（后端强制校验）；店长下放待拍板后配置 -->
        <el-menu-item index="/volunteerApply">
          <i class="el-icon-star-off"></i>
          <span slot="title">志愿者管理</span>
        </el-menu-item>
        <!-- 发起人权限一期：仅超管可见（后端 notSuper 强制校验） -->
        <el-menu-item index="/organizerApply">
          <i class="el-icon-s-custom"></i>
          <span slot="title">发起人管理</span>
        </el-menu-item>
        <el-menu-item index="/activityReport">
          <i class="el-icon-warning-outline"></i>
          <span slot="title">举报管理</span>
        </el-menu-item>
        <el-menu-item index="/dictionary">
          <i class="el-icon-s-grid"></i>
          <span slot="title">字典</span>
        </el-menu-item>

      </el-menu>
    </div>
    <div class="home-right">
      <div class="home-top">
        <div style="display:flex;align-items:center;gap:12px;">
          <el-dropdown @command="handleCommand">
            <div class="user-center" split-button style="text-align: right">
              <span>账户：{{systemUser}}</span>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-lock" command="b">设置密码</el-dropdown-item>
              <el-dropdown-item icon="el-icon-back" command="c">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="danger" plain size="small" icon="el-icon-switch-button" @click="loginOut">退出登录</el-button>
        </div>
      </div>
      <div class="home-main">
        <router-view/>
      </div>
    </div>
    <el-dialog title="修改密码" :visible.sync="dialog" width="400px">
      <el-form :model="form" label-width="100px" ref="form">
        <el-form-item label="原密码" prop="oldPwd">
          <el-input v-model="form.oldPwd" placeholder="请输入原密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPwd">
          <el-input v-model="form.newPwd" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPwd">
          <el-input v-model="form.confirmPwd" placeholder="请再次输入新密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="pwdSubmit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {systemUserChangePassword} from "@/common/js/index.js"

export default {
  name: 'home',
  data() {
    return {
      systemUser: localStorage.getItem('systemUser'),
      systemUserId: localStorage.getItem('systemUserId'),
      dialog: false,
      form: {
        oldPwd: "",
        newPwd: "",
        confirmPwd: ""
      },
    }
  },
  computed: {},
  methods: {
    pwdSubmit(id){
      if (this.form.newPwd === this.form.confirmPwd) {
        let subData = "password=" +  this.form.newPwd + "&oldPassword=" +  this.form.oldPwd+ "&id=" +  this.systemUserId
        systemUserChangePassword(subData).then(res => {
          if (res) {
            this.dialog = false;
            this.$message.success("修改密码成功")
          }
        })
      } else {
        this.$message.error("两次输入的新密码不一致")
      }
    },
    handleCommand(command) {
      switch (command) {
        case 'b':
          this.dialog = true;
          break;
        case 'c':
          this.loginOut();
          break;
        default:
          break;
      }
    },
    loginOut() {
      localStorage.removeItem("token");
      localStorage.removeItem("sessionid");
      localStorage.removeItem("systemUser");
      localStorage.removeItem("systemUserId");
      this.$message.success('已退出登录');
      this.$router.push({
        name: 'login'
      })
    },
  },
  created() {

  },
  beforeDestroy() {
  }
}
</script>
<style scoped lang="scss">
.home {
  display: -webkit-flex; /* Safari */
  display: flex;
  height: 100%;
  /*border: 1px solid red;*/
}

.el-menu-vertical-demo {
  height: 100%;
  width: 138px;
  overflow: hidden;
}

.home-right {
  width: calc(100% - 140px);
  height: 100%;
}

.home-top {
  border-bottom: 1px solid #DDD;
  height: 50px;
  width: 100%;
  display: -webkit-flex; /* Safari */
  display: flex;
  justify-content: space-between;
  padding: 0 120px 0 1200px;

}

.home-main {
  width: 100%;
  height: calc(100% - 50px);
  /* border: 1px solid blue;*/
}

.el-menu-item.is-active {
  background-color: #409EFF !important;
}

.el-submenu .el-menu-item {
  height: 50px;
  line-height: 50px;
  padding: 0 45px;
  width: 120px;
}

.head-img {
  width: 100%;
  height: auto;
  overflow: hidden;
}
.head-img img {
  width: 100%;
  height: auto;
  display: block;
}

.user-center {
  color: #409EFF;
  font-size: 28px;
  height: 40px;
  /*background: #4A7DFA;*/
  display: -webkit-flex; /* Safari */
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  /* border-radius: 6px;*/
  margin-top: 5px;
  cursor: pointer;

  span {
    margin-top: 7px;
  }
}

.user-center .user-img {
  width: 30px;
  height: 30px;
  border-radius: 15px;
  overflow: hidden;
  margin: 5px 20px 0 0;
}

.el-dropdown-menu {
  width: 160px;
}

.notice {
  border-top-left-radius: 3px;
}
</style>
